import React, { FC } from 'react';
import PortalHeader from './portal-header';

interface QuestionnaireErrorStateProps {
  error: string
  onBack: () => void
  onRetry: () => void
}

const QuestionnaireErrorState: FC<QuestionnaireErrorStateProps> = ({
  error, onBack, onRetry,
}) => (
  <div className="adhd-portal min-h-screen flex flex-col bg-page">
    <PortalHeader />
    <div className="flex-1 flex items-center justify-center px-4">
      <div className="max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
        <div className="text-4xl mb-4">⚠️</div>
        <h3 className="text-lg font-bold text-slate-800 mb-2">
          Unable to load questionnaire
        </h3>
        <p className="text-sm text-slate-500 mb-6">
          {error || 'An unexpected error occurred. Please try again.'}
        </p>
        <div className="flex gap-3 justify-center">
          <button
            type="button"
            onClick={onBack}
            className="px-5 py-2.5 rounded-xl text-sm font-semibold border-2 border-slate-200 text-slate-600 hover:bg-slate-50 cursor-pointer"
          >
            ← Back
          </button>
          <button
            type="button"
            onClick={onRetry}
            className="px-6 py-2.5 rounded-xl font-semibold text-sm text-white bg-brand cursor-pointer"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default QuestionnaireErrorState;
